export const columns = [
    {
        title: "SN号",
        dataIndex: "snNumber",
        width: 200,
        align: "center"
    },
    {
        title: "创建时间",
        dataIndex: "localDate",
        width: 120,
        align: "center"
    },
    {
        title: "生产批号",
        dataIndex: "materialBatch",
        width: 165,
        align: "center"
    },
    {
        title: "型号",
        dataIndex: "model",
        align: "center",
        width: 105,
    }, {
        title: "新设备",
        slots: { customRender: 'isNewDevice' },
        align: "center",
        width: 100,
    }, {
        title: "闭环状态",
        slots: {
            customRender: "closedLoopStatus"
        },
        align: "center",
        width: 120,
    },
    {
        title: "设备状态",
        children: [
            {
                title: "送检次数",
                dataIndex: "inspectionFrequency",
                width: 100,
                align: "center"
            },
            {
                title: "状态",
                dataIndex: "status",
                width: 80,
                align: "center"
            },
        ],
    },
    {
        title: "第1次送检问题",
        children: [
            {
                title: "问题",
                slots: { customRender: 'question1' },
                align: "center",
                width: 260,
            },
            {
                title: "问题类型",
                slots: { customRender: 'questionType1' },
                align: "center",
                width: 100,
            },

            {
                title: "送检人",
                dataIndex: "inspectionPersonnel1",
                width: 90,
                align: "center"
            },
            {
                title: "质检人",
                dataIndex: "qualityPersonnel1",
                width: 90,
                align: "center"
            },
        ],
    },
    {
        title: "第2次送检问题",
        children: [
            {
                title: "问题",
                slots: { customRender: 'question2' },
                align: "center",
                width: 260,
            },
            {
                title: "问题类型",
                slots: { customRender: 'questionType2' },
                align: "center",
                width: 100,
            },
            {
                title: "送检人",
                dataIndex: "inspectionPersonnel2",
                width: 90,
                align: "center"
            },
            {
                title: "质检人",
                dataIndex: "qualityPersonnel2",
                width: 90,
                align: "center"
            },
        ],
    },
    {
        title: "操作",
        slots: {
            customRender: "action",
        },
        width: 80,
        align: "center",
        fixed: 'right'
    }
];

export const productColumns = [
    {
        title: "SN号",
        dataIndex: "snNumber",
        width: 210,
        align: "center"
    },
    {
        title: "创建时间",
        dataIndex: "localDate",
        width: 120,
        align: "center"
    },
    {
        title: "型号规格",
        dataIndex: "modelSpecifications",
        align: "center",
        width: 120,
    }, {
        title: "输出SN号",
        dataIndex: "outputSnNumber",
        align: "center",
        width: 210,
    },
    {
        title: "设备状态",
        children: [
            {
                title: "送检次数",
                dataIndex: "inspectionFrequency",
                width: 100,
                align: "center"
            },
            {
                title: "状态",
                dataIndex: "status",
                slots: {
                    customRender: "status"
                },
                width: 80,
                align: "center"
            },
        ],
    },
    {
        title: "流水号",
        dataIndex: "serialNumber",
        width: 160,
        align: "center"
    }, {
        title: "来源工序",
        slots: {
            customRender: "sourceProcess"
        },
        align: "center",
        width: 120,
    }, {
        title: "闭环状态",
        slots: {
            customRender: "closedLoopStatus"
        },
        align: "center",
        width: 120,
    },
    {
        title: "第1次送检问题",
        children: [
            {
                title: "问题",
                slots: { customRender: 'question1' },
                align: "center",
                width: 260,
            },
            {
                title: "问题类型",
                slots: { customRender: 'questionType1' },
                align: "center",
                width: 100,
            },

            {
                title: "送检人",
                dataIndex: "inspectionPersonnel1",
                width: 90,
                align: "center"
            },
            {
                title: "质检人",
                dataIndex: "qualityPersonnel1",
                width: 90,
                align: "center"
            }, {
                title: "原因",
                dataIndex: "reason1",
                width: 90,
                align: "center"
            }, {
                title: "解决方案",
                dataIndex: "solution1",
                width: 120,
                align: "center"
            }
        ],
    },
    {
        title: "第2次送检问题",
        children: [
            {
                title: "问题",
                slots: { customRender: 'question2' },
                align: "center",
                width: 260,
            },
            {
                title: "问题类型",
                slots: { customRender: 'questionType2' },
                align: "center",
                width: 100,
            },
            {
                title: "送检人",
                dataIndex: "inspectionPersonnel2",
                width: 90,
                align: "center"
            },
            {
                title: "质检人",
                dataIndex: "qualityPersonnel2",
                width: 90,
                align: "center"
            }, {
                title: "原因",
                dataIndex: "reason2",
                width: 90,
                align: "center"
            }, {
                title: "解决方案",
                dataIndex: "solution2",
                width: 120,
                align: "center"
            }
        ],
    },
    {
        title: "操作",
        slots: {
            customRender: "action",
        },
        width: '110px',
        align: "center",
        fixed: 'right'
    }
];
